import React from "react";
import PieChart from "../../../../revampComponents/Charts/PieChart";
import { dashboardColors, theme } from "../../../../themes/Theme";

const PaymentStatsCard = ({ title='', data, colorScheme ,loading =false , heading=''}) => {

    return (
        <>

       {!loading && 
        <div className="paymentStatsCard-main-cont d-flex flex-column richtext-gap-4 h-100 h-full">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <p className="mb-0 PaymentStatsCard-main-title">{title}</p>
            </div>
                    <div className={`${heading === 'overview' ?'d-flex' : 'd-flex flex-column'} `}>
                        <div className={`${(heading === 'overview' && data?.length > 0) ?'w-50' : 'w-100'} `}>
                            {data?.length > 0 ? <div className="d-flex justify-content-center mb-3">
                                <PieChart type="donut" data={data} colorScheme={colorScheme} />
                            </div> :

                                <div className="w-100 text-center d-flex flex-column align-items-center richtext-justify-center nodata-PaymentStatsCard">
                                    No data to display
                                </div>
                            }</div>

                   {data?.length > 0 &&      <div className={`${heading === 'overview' ?'w-50 d-flex flex-column richtext-justify-center' : 'w-100'} `}>
                            <div className="d-flex justify-content-between align-items-center mb-3 small "
                            >
                                 <span className="payment-method-name-txt-heading">PAYMENT GATEWAY NAME</span>
                                  <span className="d-flex align-items-center richtext-gap-2">
                                        <span className="payment-method-name-number payment-method-name-txt-heading">NUMBER </span> <span className="payment-method-name-number-cent">(%)</span>
                                    </span>
                            </div>
                            {data?.map((item, idx) => (
                                <div
                                    key={idx}
                                    className="d-flex justify-content-between align-items-center mb-2 small"
                                >
                                    <div className="d-flex align-items-center richtext-gap-3">
                                        <span
                                            className="rounded-circle"
                                            style={{
                                                display: "inline-block",
                                                width: "12px",
                                                height: "12px",
                                                backgroundColor: colorScheme[idx],
                                            }}
                                        ></span>
                                        <span className="payment-method-name-txt">{item?.name}</span>
                                    </div>
                                    <span className="d-flex align-items-center richtext-gap-2">
                                        <span className="payment-method-name-number"> {item?.value}</span> <span className="payment-method-name-number-cent">({item.percentage}%)</span>
                                    </span>
                                </div>
                            ))}
                        </div>}</div>
            <style>{
                `
                .paymentStatsCard-main-cont{
                    padding:24px 30px;
                    border: 1px solid #C3CDDF;
                    box-shadow:${heading === 'overview' ?'0 0 0':'0px 0px 14px 9px #002E6E1A' }  ;
                    border-radius:4px;

                }
                 .payment-method-name-number{
                        font-size:14px;
                    font-weight:400;
                    color:${dashboardColors[theme].primaryTextColor};
                }
                .PaymentStatsCard-main-title{
                    font-size:18px;
                    font-weight:600;
                    color:${dashboardColors[theme].primaryTextColor};
                }
                .payment-method-name-txt{
                    font-size:14px;
                    font-weight:500;
                    color:${dashboardColors[theme].primaryTextColor};
                }
                .payment-method-name-txt-heading{
                    font-size:13px;
                    font-weight:600;
                    color:${dashboardColors[theme].primaryTextColor};
                }
               
                .payment-method-name-number-cent{
                        font-size:14px;
                    font-weight:400;
                    color:#23A738;
                }
                .nodata-PaymentStatsCard{
                    min-height:150px;
                }
                `

            }</style>
        </div> }
        </>
    );
};

export default PaymentStatsCard;
